<template>
  <!-- 1) While we’re waiting for the embed-widget to initialize -->
  <div v-if="!initialized" class="w-full h-[24rem] bg-gray-50 rounded animate-pulse"></div>

  <!-- 2) Once initialized: show chat when live -->
  <div v-else-if="isLive" id="tawk_inline_chat" class="w-full h-full min-h-[24rem]"></div>

  <!-- 3) Otherwise show your offline placeholder -->
  <div v-else class="w-full h-full min-h-[24rem] p-6 bg-white shadow-md rounded text-center">
    <p class="text-gray-500">{{ t("chat.offlineMessage") }}</p>
    <p class="mt-2 text-sm text-gray-400">{{ t("chat.businessHours") }}</p>
  </div>
</template>
<script setup lang="ts">
import { ref, onMounted } from "vue";
import { useI18n } from "vue-i18n";
const { t } = useI18n();
const PROPERTY_ID = "68114879a34a48190eed1140";
const EMBED_WIDGET_ID = "1iq3emg65"; // your Embed-type widget ID

const initialized = ref(false);
const isLive = ref(false);

onMounted(() => {
  /**
   * Try to wire in the embed widget.
   * We rely on the fact that InlineLiveChat.vue
   * has already loaded the Tawk script once.
   */
  function tryInit() {
    const Tawk_API = (window as any).Tawk_API;
    if (!Tawk_API?.switchWidget) return;

    // 1) Tell it which container in our template to use
    Tawk_API.embedded = "tawk_inline_chat";

    // 2) Swap in the Embed-type widget
    Tawk_API.switchWidget({ propertyId: PROPERTY_ID, widgetId: EMBED_WIDGET_ID }, (err: any) => {
      initialized.value = true;
      if (err) {
        return;
      }

      // 3) Initial online/offline check
      isLive.value = Tawk_API.getStatus?.() === "online";

      // 4) Subscribe to live status updates
      Tawk_API.onStatusChange = (status: string) => {
        isLive.value = status === "online";
      };
    });
  }

  // If the global script is already there, go for it...
  if ((window as any).Tawk_API?.switchWidget) {
    tryInit();
  } else {
    // Otherwise wait for the custom load event from InlineLiveChat.vue,
    // with a fallback poll in case the event missed.
    const onLoaded = () => {
      tryInit();
      window.removeEventListener("tawkScriptLoaded", onLoaded);
    };
    window.addEventListener("tawkScriptLoaded", onLoaded);

    const timer = setInterval(() => {
      if ((window as any).Tawk_API?.switchWidget) {
        tryInit();
        clearInterval(timer);
        window.removeEventListener("tawkScriptLoaded", onLoaded);
      }
    }, 200);
  }
});
</script>

<style scoped>
#tawk_inline_chat {
  width: 100%;
  height: 100%;
  min-height: 24rem;
}
</style>
